import React from 'react';
import { Combo } from '@fx-ui/fine-design';
import { MobileAreaCodeSelector } from './components';
import { getAreaCodeList, getCodeByFullText } from '../../utils';
import { platformIntl } from '../../constants';
import { globalState } from '../../models';

interface AreaCodeProps {
    areaCode: string;
    disabled: boolean;
    height?: string | number;
    onAreaCodeChange: (areaCodeVal: string) => void;
}

/**
 * 手机区号选择组件
 */
const AreaCode: React.FC<AreaCodeProps> = (props) => {
    const { areaCode, disabled, height, onAreaCodeChange } = props;

    if (globalState.isMobile) {
        return (
            <MobileAreaCodeSelector
                areaCode={areaCode}
                disabled={disabled}
                height={height}
                onAreaCodeChange={onAreaCodeChange}
            />
        );
    }
    return (
        <Combo
            searchInputPlaceholder={platformIntl.get('phone.area.code.placeholder')}
            hasClear={false}
            autoFocus={false}
            disabled={disabled}
            className="fx-area-code"
            style={{ height: height }}
            value={areaCode}
            groupItems={getAreaCodeList()}
            valueRender={(item) => {
                if (item) {
                    return getCodeByFullText(item.text);
                }
            }}
            dropdownStyle={{
                width: '200px'
            }}
            onChange={(value) => onAreaCodeChange(value as string)}
        />
    );
};

export default AreaCode;
